// extracted by mini-css-extract-plugin
export default {"smallOverlay":"styles_smallOverlay__ZjZnB"};